<template>
  <div class="mt-1">
    <div v-if="isWizardReady">
      <!-- STATUS: {{ sts }} -->
      <wizard
        :resourceId="parseInt(id)"
        repository="communication_procedure"
        :title="wizardProps.title"
        :subtitle="wizardProps.subtitle"
        :color="wizardProps.color"
        :startIndex="wizardProps.startIndex"
        :extras="{ status_procedure: sts, communication_type, category }"
        :tabs="wizardTabs"
        @fetch="loadIndex()"
        @status="onStatus"
      >
      </wizard>
    </div>
    <div class="actions-toolbar">
      <div class="d-flex justify-content-end pr-2" style="gap: 10px">
        <b-button-group
          v-b-toggle.sidebar-1
          :class="`filter-button-group btn--smaller btn--transparent align-items-center gap-3${
            countActiveFilters ? ' active' : ''
          }`"
          :title="getDefaultFilterMessage()"
        >
          <base-icon name="filters" width="23" height="23" />
          <span style="font-size: 14px; font-weight: 500">{{
            computedFilterTitle
          }}</span>
        </b-button-group>
        <export-options
          :exportUrl="exportUrl"
          :repository="repository"
          resource="communication_groupings"
          :tableRef="$refs[tableRef]"
          :filter="filter"
          :options="[
            {
              code: 'LISACOM',
              label: null,
              formats: ['csv', 'pdf'],
            },
          ]"
        ></export-options>
      </div>
    </div>

    <b-sidebar
      id="sidebar-1"
      :title="computedFilterTitle"
      :backdrop="true"
      width="50dvw"
      :visible="open_filter"
      @change="onSidebarFilterChange"
      shadow
      right
    >
      <b-form @submit.prevent="onSearch(filterName)">
        <div class="filter">
          <div class="filter-item">
            <base-select
              name="scartate"
              label="Scartate"
              :options="discardedOptions"
              v-model="filter.byCommunicationDetail.is_discarded"
            />
          </div>
          <div class="filter-item" data-type="registry-group">
            <div>
              <b-button-toolbar>
                <b-button-group>
                  <base-input
                    :class="{
                      'filter-item-inner-wrapped': true,
                    }"
                    name="Anagrafica"
                    label="Anagrafica"
                    v-model="form.inpt_label_registry"
                    :readonly="true"
                  />
                  <b-button
                    class="btn-quick btn--light"
                    size="sm"
                    text="Button"
                    variant="lisaweb"
                    title="Cerca anagrafica"
                    @click="openQuickSearchRegistry"
                  >
                    <base-icon name="search" width="14" height="14"></base-icon>
                  </b-button>
                  <b-button
                    v-if="form.inpt_label_registry"
                    class="btn--light btn--alert"
                    size="sm"
                    text="Button"
                    variant="lisaweb"
                    @click="resetRegistryId"
                    title="Elimina Anagrafica"
                  >
                    <base-icon name="trash" width="22" height="22"></base-icon>
                  </b-button>
                </b-button-group>
              </b-button-toolbar>
            </div>
          </div>
          <quick-search-registry-modal
            ref="quickSearchRegistry"
            @input="handleRegistryModalInput"
          >
          </quick-search-registry-modal>
          <div class="filter-item" data-type="registry-group-info">
            <div class="details-card-wrapper" v-if="registry_data">
              <b-card>
                <div
                  slot="header"
                  class="d-flex justify-content-between align-items-center"
                >
                  <p class="mb-0 d-inline-block align-middle">
                    <strong>Informazioni anagrafica selezionata</strong>
                  </p>
                </div>
                <div
                  class="custom-grid-wrapper"
                  v-html="toInfoData(registry_data, 'registry')"
                ></div>
              </b-card>
            </div>
          </div>
        </div>
        <div class="actions-filter-sidebar-wrapper">
          <b-button
            type="submit"
            variant="lisaweb"
            size="sm"
            v-b-toggle:sidebar-1
            >Cerca
          </b-button>
          <b-button
            class="btn--transparent btn-reset"
            type="button"
            size="sm"
            @click="onClearFilter(filterName)"
            >Reset
          </b-button>
        </div>
      </b-form>
    </b-sidebar>
    <div class="status-filter">
      <div class="pill-wrapper my-3">
        <span
          class="pill"
          v-for="(value, name, index) in activeFilters"
          :key="index"
          data-color="white"
        >
          <template>
            <span v-b-toggle.sidebar-1 :data-filter="name"
              ><strong>{{ sidebarFilterName(name, context) }}</strong
              >:&nbsp;{{ sidebarFilterValue(name, value) }}</span
            >
            <span tabindex="0">
              <span
                @click="resetSingleSidebarFilter(name)"
                title="Rimuovi filtro"
                >×</span
              >
            </span>
          </template>
        </span>
        <template v-if="this.countActiveFilters">
          <span
            class="pill"
            data-color="alert"
            @click="resetAllFilters()"
            title="Rimuovi i filtri e apri il pannello per una nuova ricerca"
          >
            <span
              ><strong>Reset ({{ this.countActiveFilters }})</strong></span
            >
            <span><span>×</span></span>
          </span>
        </template>
      </div>
    </div>
    <div v-if="isWizardReady">
      <communication-groupings
        :filterOn="{
          byRelations: [
            'byRegistry',
            'byInsurancePayment',
            'byBookEntry',
            'byInsuranceAncillary',
          ],
        }"
        :fields="fields"
        @manualFetch="manualFetch"
        :sort-field="'date'"
        :sort-order-desc="false"
        repository="communication_grouping"
        resource="communication_groupings"
        :filterName="filterName"
        :performedSearch="computePerformedSearch"
        :filterCount="countActiveFilters"
        :ref="tableRef"
        :onlyActions="['infomodal']"
        @loadIndex="loadIndex"
        :extras="{
          status_procedure: sts,
          communication_type,
        }"
      ></communication-groupings>
    </div>
  </div>
</template>

<script>
import ShortcutMixin from "@/mixins/ShortcutMixin";
import FormMixin from "@/mixins/FormMixin";
import CustomFiltersMixin from "@/mixins/CustomFiltersMixin";
import CommunicationGroupings from "@/components/tables/CommunicationGroupings";
import BaseInput from "@/components/form/BaseInput";
import BaseSelect from "@/components/form/BaseSelect";
import ExportOptions from "@/components/ExportOptions";
import QuickSearchRegistryModal from "@/components/modals/quickSearchRegistry";
import Wizard from "@/components/communication/procedures/Wizard";
import { toInfoData } from "@/utils/transforms";
import { mapActions } from "vuex";
import BaseIcon from "@/components/BaseIcon";
import SidebarFilterMixin from "../../../mixins/SidebarFilterMixin";

export default {
  mixins: [FormMixin, ShortcutMixin, CustomFiltersMixin, SidebarFilterMixin],
  data() {
    return {
      sp: null, //status_procedure model for child components (injected within extras)
      isLoading: true, // to skip autofetch of table since component is mounted already with a filter set by route
      isWizardReady: false,
      exportUrl: null,
      repository: "communication_procedure",
      resource: "communication_procedures",
      filter: this.initFilter(),
      filterName: "filterCommunicationGroupings",
      activeFilters: {},
      performedSearch: false,
      id: this.$route.params.id, // communication_procedures.id
      status_procedure: this.$route.params.status_procedure,
      communication_type: this.$route.params.communication_type,
      category: this.$route.params.category,
      tableRef: "CommunicationProceduresTableRef",
      registry_data: null,
      form: {
        inpt_label_registry: "",
        communication_procedure: {
          status_procedure: null,
          communication_type: null,
        },
      },
      fields: [
        {
          key: "registry",
          label: "Destinatario",
          sortable: true,
          sortByFormatted: (value, key, item) => {
            return toInfoData(item.registry, "registryfullname", null);
          },
        },
        {
          key: "address",
          label: "Indirizzo",
        },
        {
          key: "address_books",
          label: "Contatti",
        },
        {
          key: "details",
          label: "Righe",
        },
        {
          key: "note",
          label: "Note",
        },
        {
          key: "total",
          label: "Totale",
          thClass: "text-right",
          thStyle: {
            "text-align": "right",
          },
          tdClass: "text-right",
        },
        // {
        //   key: "communication_procedure_id",
        //   label: "ID Procedura",
        // },
      ],
      discardedOptions: [
        { text: "SI", value: "Y" },
        { text: "NO", value: "N" },
      ],
      wizardProps: {
        startIndex: 1,
        title: "Procedura guidata",
        subtitle: `Stai inviando per ${this.getCommunicationTypeText()}`,
        nextButtonText: "Prossimo",
        backButtonText: "Precedente",
        finishButtonText: "Finisci",
        // stepSize: {
        //   type: String,
        //   default: "md",
        //   validator: (value) => {
        //     let acceptedValues = ["xs", "sm", "md", "lg"];
        //     return acceptedValues.indexOf(value) !== -1;
        //   },
        // },
        /***
         *  Sets validation (on/off) for back button. By default back button ignores validation
         */
        validateOnBack: Boolean,
        /***
         * Applies to text, border and circle
         */
        color: "#1c97d8", //circle, border and text color
        /***
         *  Is set to current step and text when beforeChange function fails
         */
        errorColor: "#8b0000",
        /**
         * Can take one of the following values: 'circle|square|tab`
         */
        shape: "circle",
        /**
         * name of the transition when transition between steps
         */
        // transition: {
        //   type: String,
        //   default: "", //name of the transition when transition between steps
        // },
        /***
         * Index of the initial tab to display
         */
        // startIndex: {
        //   type: Number,
        //   default: 0,
        // },
      },
      // wizardTabProps: {
      //   title: {
      //     type: String,
      //     default: "",
      //   },
      //   /***
      //    * Icon name for the upper circle corresponding to the tab
      //    * Supports themify icons only for now.
      //    */
      //   icon: {
      //     type: String,
      //     default: "",
      //   },
      //   /***
      //    * Only render the content when the tab is active
      //    */
      //   lazy: {
      //     type: Boolean,
      //     default: false,
      //   },
      //   /***
      //    * Function to execute before tab switch. Return value must be boolean
      //    * If the return result is false, tab switch is restricted
      //    */
      //   beforeChange: {
      //     type: Function,
      //   },
      // },
      // status_procedure: {
      //   0: "Inzio",
      //   1: "Esclusioni",
      //   2: "Raggruppamenti",
      //   3: "Modifica",
      //   4: "Template",
      //   5: "Invio",
      // },
      wizardTabs: [
        {
          title: "Esclusioni",
          icon: "b-dash-circle",
          component: "Step1",
          lazy: true,
          index: 0,
        },
        {
          title: "Raggruppamenti",
          icon: "b-grid",
          component: "Step2",
          lazy: true,
          hide: false,
          index: 1,
        },
        {
          title: "Modifica",
          icon: "b-pencil-square",
          component: "Step3",
          lazy: true,
          index: 2,
        },
        {
          title: "Template",
          icon: "b-file-earmark-medical",
          component: "Step4",
          lazy: true,
          index: 3,
        },
      ],
    };
  },
  components: {
    BaseIcon,
    BaseInput,
    BaseSelect,
    CommunicationGroupings,
    QuickSearchRegistryModal,
    Wizard,
    ExportOptions,
  },
  methods: {
    toInfoData,
    getCommunicationTypeText() {
      const ct =
        this.communication_type ?? this.$route.params.communication_type;
      let text = "";
      switch (ct) {
        case 0:
          text = "Email";
          break;
        case 2:
          text = "SMS";
          break;
        case 3:
          text = "Posta";
          break;
        default:
          text = "";
          break;
      }
      return text;
    },
    initFilter() {
      let init = {
        // byAttribute: {
        //   communication_procedure_id: this.$route.params.id,
        // },
        byCommunicationProcedure: {
          id: this.$route.params.id,
        },
        // byCommunicationDetail: {
        //   is_discarded_by_broker: "N",
        //   is_discarded_by_default_method: "N",
        // },
        byCommunicationDetail: {
          // is_discarded_by_broker: "N",
          // is_discarded_by_default_method: "N",
          is_discarded: "N",
        },
        // byDiscarded: "N",
        byRegistry: {
          id: null,
        },
        quickSearchRegistry: {
          label: "",
          formLabel: "",
          data: null,
          formData: "",
        },
      };
      return init;
    },
    onStatus(status) {
      // inietto il nuovo valore nella table, che tramite prop extras vien passato al tab General
      console.debug("onStatus: ", status);
      // this.isWizardReady = false;
      this.sp = status;
      // this.$refs[this.tableRef].sp = status;
      // this.isWizardReady = true;
    },
    onSubmit() {
      this.isLoading = true;
      this.update(this.repository, this.id)
        .then(() => {
          // this.$store.dispatch("auth/book_tags");
          this.$showSnackbar({
            preset: "success",
            text: `Azione Completata: procedura aggiornata`,
          });
          // this.shortcut("book_tags.index", null, null, "filterBookTags");
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    loadIndex() {
      console.log("loadIndex");
      this.isLoading = true;
      let name = this.filterName;
      let criteria = this.filter;
      this.saveFilterByName({ name, criteria });
      this.exportUrl = this.$refs[this.tableRef].loadFilter(
        this.$refs[this.tableRef].filterName,
      );
      this.$refs[this.tableRef]
        .fetch()
        .then(() => {
          const table = this.$refs[this.tableRef];
          if (table.items && Array.isArray(table.items)) {
            table.items.forEach((item) => {
              item.communication_details.sort(
                (a, b) =>
                  new Date(
                    a?.insurance_payment?.referring_at ||
                      a?.custom_data?.date ||
                      0,
                  ) -
                  new Date(
                    b?.insurance_payment?.referring_at ||
                      b?.custom_data?.date ||
                      0,
                  ),
              );
            });
          }
          this.removeFilterByName(name);
          this.isLoading = false;
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: errMsg,
          });
        });
      // const Repo = RepositoryFactory.get("communication_grouping");
      // let queryString = `byRegistry&byCommunicationProcedure[id]=${this.id}`;
      // Repo.index(queryString)
      //   .then((response) => {
      //     this.$refs[this.tableRef].items = response.data.data;
      //     this.isLoading = false;
      //   })
      //   .catch((error) => {
      //     let errMsg = this.$getErrorMessage(error);
      //     this.$showSnackbar({
      //       preset: "error",
      //       text: errMsg,
      //     });
      //   });

      // this.fetchEditForm(this.repository, this.id).then(() => {
      //   this.isLoading = false;
      // });
    },
    setWizardStep(number) {
      // Step1, Step2, ...
      this.wizardProps.startIndex = number;
    },
    manualFetch() {
      this.resetAllFilters();
    },
    resetAllFilters() {
      this.onClearFilter(this.filterName);
      this.activeFilters = {};
      const table = this.tableRef ? this.$refs[this.tableRef] : null;
      if (table) {
        table.items = [];
        table.totalRows = 0;
      }
      this.open_filter = true;
    },
    retriveActiveFilters(obj = this.filter, parentKey = "") {
      for (const key in obj) {
        const value = obj[key];
        // Build the property path (for nested properties)
        const fullPath = parentKey ? `${parentKey}.${key}` : key;

        if (key === "byCustom" && typeof value === "object") {
          // Special handling for `byCustom`: Return everything in the inner object only if `value` is not null
          for (const innerKey in value) {
            const innerValue = value[innerKey];
            if (
              innerValue &&
              typeof innerValue === "object" &&
              "value" in innerValue
            ) {
              /* By default "value" is euqal to `null`, after it's been filled and being consequently emptied it's equal to an empty string */
              if (!(innerValue.value === null || innerValue.value === "")) {
                this.activeFilters[`${fullPath}.${innerKey}.value`] =
                  innerValue.value;
              }
            }
          }
        } else if (value && Array.isArray(value)) {
          if (value.length === 1) {
            this.activeFilters[fullPath] = value[0];
          } else if (value.length > 1) {
            // If it's an array don't print all the values recorsively
            this.activeFilters[fullPath] = `${value.length} selezioni`;
          }
        } else if (value && typeof value === "object") {
          // Recursively process nested objects for non-`byCustom` keys
          Object.assign(
            this.activeFilters,
            this.retriveActiveFilters(value, fullPath),
          );
        } else if (value !== null && String(value).length) {
          // Append non-null values
          this.activeFilters[fullPath] = value;
        }
      }

      delete this.activeFilters["byCommunicationProcedure.id"];
      delete this.activeFilters["quickSearchRegistry.formLabel"];
      delete this.activeFilters["quickSearchRegistry.formData"];
      return this.activeFilters;
    },
    onSearch(name) {
      this.performedSearch = true;
      this.activeFilters = {};
      this.activeFilters = this.retriveActiveFilters();
      let criteria = this.filter;
      this.saveFilterByName({ name, criteria });
      this.exportUrl = this.$refs[this.tableRef].loadFilter(
        this.$refs[this.tableRef].filterName,
      );
      this.removePaginationByName(name);
      this.$refs[this.tableRef].currentPage = 1;
      this.$refs[this.tableRef].fetch();
      criteria.quickSearchRegistry.label = this.form.inpt_label_registry;
      criteria.quickSearchRegistry.formLabel = "form.inpt_label_registry";
      criteria.quickSearchRegistry.data = this.registry_data;
      criteria.quickSearchRegistry.formData = "registry_data";
    },
    onClearFilter(name) {
      // this.resetFilter();
      this.resetPagination();
      this.resetRegistryId();
      this.removeFilterByName(name);
      this.removePaginationByName(name);
      this.removeSortByName(name);
      this.$refs[this.tableRef].sortBy = "";
      this.$refs[this.tableRef].sortDesc = false;
      this.filter = this.initFilter();
      // this.onSearch(name);
    },
    // onDestroyDetail(id) {
    //   const Repo = RepositoryFactory.get("communication_detail");
    //   Repo.destroy(id)
    //     .then(() => {
    //       this.loadIndex();
    //       this.$showSnackbar({
    //         preset: "success",
    //         text: "Dettaglio eliminato con successo",
    //       });
    //     })
    //     .catch((error) => {
    //       let errMsg = this.$getErrorMessage(error);
    //       this.$showSnackbar({
    //         preset: "error",
    //         text: `${errMsg}`,
    //       });
    //     });
    // },
    openQuickSearchRegistry() {
      this.$bvModal.show("quickSearchRegistryModal");
    },
    handleRegistryModalInput(value) {
      this.filter.byRegistry.id = value.id;
      this.registry_data = value;
      this.form.inpt_label_registry = this.toInfoData(
        this.registry_data,
        "registryfullname",
      );
      this.$bvModal.hide("quickSearchRegistryModal");
    },
    resetRegistryId() {
      this.registry_data = null;
      this.form.inpt_label_registry = null;
      this.filter.byRegistry.id = null;
    },
    ...mapActions("filters", {
      saveFilterByName: "saveByName",
      removeFilterByName: "removeByName",
    }),
    ...mapActions("pagination", { removePaginationByName: "removeByName" }),
    ...mapActions("sorts", {
      removeSortByName: "removeByName",
    }),
  },
  beforeMount() {
    console.log(
      this.$route.params.id,
      this.$route.params.status_procedure,
      this.$route.params.communication_type,
    );
    // init the status procedure
    this.sp = this.$route.params.status_procedure;
    // se status_procedure è 1,2,3 o 4 (numero di wizardTabs) allora
    //          stepIndex è 0,1,2 o 3
    // altrimenti (status_procedure = 5) stepIndex è 3 (non 4)
    let stepIndex =
      this.status_procedure <= this.wizardTabs.length
        ? this.status_procedure - 1
        : this.wizardTabs.length - 1;
    this.setWizardStep(stepIndex);
    this.isWizardReady = true;
  },
  mounted() {
    this.loadIndex();
    // keep the filter sidebar closed on page load (like /bank-accounts)
    this.open_filter = false;
  },
  computed: {
    countActiveFilters() {
      return Object.keys(this.activeFilters).length;
    },
    computedFilterTitle() {
      return `Filtri${
        this.countActiveFilters ? ` (${this.countActiveFilters})` : ""
      }`;
    },
    computePerformedSearch() {
      return this.performedSearch;
    },
    rep() {
      return this.repository;
    },
    sts() {
      return this.sp;
      // return this.$refs[this.tableRef]
      //   ? this.$refs[this.tableRef].status_procedure
      //   : this.sp;
    },
  },
};
</script>
